import React from 'react';
import PageLayout from '../../components/Layout/PageLayout';

const IndexBaseUniverse = props => {
  return <PageLayout>{props.location.pathname}</PageLayout>;
};

export default IndexBaseUniverse;
